import DataTable from "react-data-table-component";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import Popup from "react-popup";
import { useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import PagoSepelioService from "../../../../services/pagos/PagoSepelioService";
import { WizardContext } from "../../../generico/CustomStepWizard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export const PagoSepelioPaso2 = (props) => {

    const sepelioContext = useContext(WizardContext);

    const { state, setState } = sepelioContext;

    const notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });


    const getColumn = () => {
        return [
            {
                name: "concepto",
                selector: row => row.concepto,
            },
            {
                name: "valor",
                selector: row => row.valor,
            },
        ];
    }

    const getDatosCuenta = () => {
        var pagoValor = formatoSeparadorMilesValue(state.infoPagare?.montoAPagar) + " " + state.moneda + ".";
        var respuesta = [
            { concepto: "Titular de la Cuenta:", valor: state.ctaFullData?.denominacion },
            { concepto: "Nro de Solicitud:", valor: state.infoPagare.idSolicitud },
            { concepto: "Empresa:", valor: state.infoPagare.nombreEmpresa },
        ];

        if (state.infoPagare.nombreSubsidiado) respuesta.push({ concepto: "Subsidiado/a:", valor: state.infoPagare.nombreSubsidiado });

        respuesta = [
            ...respuesta,
            { concepto: "Fecha de Pagaré:", valor: state.infoPagare.fechaPagare },
            { concepto: "Fecha Vencimiento:", valor: state.infoPagare.fechaVencimiento },
            { concepto: "Total a Pagar:", valor: pagoValor },
        ];

        return respuesta;
    }

    const confirmarOperacion = () => {

        trackPromise(
            PagoSepelioService.pagoSepelio(
                state.ctaFullData?.idAhorro,
                state.infoPagare?.montoAPagar
            ).then((response) => {

                let { codigoRetorno, mensajeRetorno, datos } = response.data;

                if (codigoRetorno === "0") {
                    setState({ ...state, codOperacion: datos })
                    props.nextStep();
                } else {
                    Popup.queue(notifiPopup("Info", mensajeRetorno));
                }
            })
        );
    };

    return (
        <div>
            <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                    <div className="form-group">
                        <label className="input-label">Cuenta Origen (a debitar):</label>
                        <br />
                        {state.ctaFullData !== undefined && (
                            <label className="input-label-bold">
                                {state.ctaFullData?.idAhorro}-
                                {state.ctaFullData?.descripcion} Saldo:{" "}
                                {formatoSeparadorMilesValue(state.ctaFullData?.disponible)}{" "}
                                {state.ctaFullData?.moneda}.
                            </label>
                        )}
                    </div>
                </div>
            </div>

            <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                    <div className="row">
                        <div className="table-responsive">
                            <DataTable
                                noHeader={true}
                                columns={getColumn()}
                                data={getDatosCuenta()}
                                dense={true}
                                noDataComponent="Ingrese un número de contrato para mostrar la información"
                                responsive={true}
                                noTableHead={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-lg-8 col-md-6">
                <label className="input-label-bold">
                            ¿Está seguro que desea CONFIRMAR la operación?
                            <br />
                        </label>
                </div>
                <div className="col-lg-2 col-md-3">
                <button
                            className="btn btn-cu-quintary btn-consulta"
                            onClick={props.previousStep}
                        >
                          <FontAwesomeIcon icon={faArrowLeft}  />  Volver
                        </button>
                </div>
                <div className="col-lg-2 col-md-3">
                <button
                            className="btn btn-cu-primary"
                            onClick={confirmarOperacion}
                        >
                            {" "}
                            Confirmar <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                </div>
             
            </div>
        </div>
    );
}